import omit from 'lodash/omit';
import { getBaseFilterFromIndexableUrl, getDefaultQueryParamsKeys } from './url';

export const getNewLocationSearch = ({
    isIndexableFiltersRemovalFeatureActive,
    seoUrlPath,
    requestParameters,
    productsPerPage
}) => {
    // default parameters and indexable filters should be removed
    if (isIndexableFiltersRemovalFeatureActive) {
        const indexableFiltersKey = getBaseFilterFromIndexableUrl(seoUrlPath);
        const defaultParamsKeys = getDefaultQueryParamsKeys(requestParameters, productsPerPage);
        const params = omit(requestParameters, [...defaultParamsKeys, indexableFiltersKey]);
        return `?${new URLSearchParams(params).toString()}`;
    }

    const locationParams = new URLSearchParams(requestParameters);
    return `?${locationParams.toString()}`;
};
